<ng-container *ngIf="showAutoExposedTcForm; else regularForm">
  <div>
    <app-shared-loading *ngIf="loading && isVisible" [hintText]="displayMessage && loadingMessage" [dialogStyle]="displayMessage"></app-shared-loading>
    <div class="contentBox embebedTCForm">
      <div class="col-7">
        <div class="methodInfo">
          <div class="iframeContainer">
            <iframe id="creditCardIframe" [src]="iframeUrl | safe" frameborder="0" width="100%" height="100%" [onload]="initIframe.bind(this)"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #regularForm>
  <div [class]="isVisible ? '' : 'hidden'">
    <app-shared-loading *ngIf="loading && isVisible" [hintText]="displayMessage && loadingMessage" [dialogStyle]="displayMessage"></app-shared-loading>
    <div class="general-title">
      <h1 class="pl-1 title">{{ 'cash-Subtitle' | translation | async }}</h1>
    </div>
    <app-return-methods [itsMobileCtrl]="true" [unique]="''" (RT)="changeMethod()"></app-return-methods>
    <div class="contentBox embebedTCForm">
      <div class="col-3">
        <div class="info-logo-container">
          <img [src]="info?.logo ?? '' | safe" class="payment_method_no_interactive" alt="Tarjeta de crédito" />
        </div>
      </div>
      <div class="col-7">
        <div class="methodInfo">
          <app-return-methods [itsMobileCtrl]="false" [unique]="''" (RT)="changeMethod()"></app-return-methods>
          <h1>{{ 'cc-Title' | translation | async }}</h1>
          <p *ngIf="useEmbedWallet && wallet != null">También puedes pagar con la tarjeta almacenada en tu Payválida Wallet haciendo <a (click)="continueWithWallet()">click aquí</a></p>
          <div class="iframeContainer">
            <iframe id="creditCardIframe" [src]="iframeUrl | safe" frameborder="0" width="100%" height="100%" [onload]="initIframe.bind(this)"></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
